(function (){
    'use strict';

    angular
        .module('manage-workshops', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize'
        ]);
})();